<template>
    <section class="dpp-keyinsights">
        <div class="grid xs-grid-cols-1" v-if="getKeyInsights.length">
            <h2 class="f4 text-bold singleline">
                Key insights
            </h2>
            <div class="list-card">
                <mvtShifter ref="shifter">
                    <div v-scroll="item.scrollInto" @click="changeTab(item.value)" class="insight-card flex p-y-2 p-x-2 bg-default corner" v-for="(item, i) in getKeyInsights" :key="i">
                        <i class="f3" :class="item.icon"> </i>
                        <div class="nogap flex vertical top">
                            <b class="f5 text-bold singleline text-capitalize">{{item.title}}</b>
                            <div class="f6" v-html="item.sub"></div>
                        </div>
                    </div>
                </mvtShifter>
            </div>
        </div>
        <div class="paragraph f7" v-if="showDisclaimerOnKeyInsights()">
            {{molang('dpp.propertyMarket.statisticsByMovoto')}}
        </div>
    </section>
</template>

<script src="./dpp-keyinsights.js"></script>

<style lang="scss">
@use './dpp-keyinsights.scss' as *;
</style>
